import { configureStore } from '@reduxjs/toolkit';
import authSlice from '@/redux/authentication/authSlice';
import catalogSlice from '@/redux/catalog/catalogSlice';
import submittalsSlice from '@/redux/submittals/submittalsSlice';
import cmsSlice from '@/redux/cms/cmsSlice';
import usersSlice from '@/redux/users/usersSlice';
import customersSlice from '@/redux/customers/customersSlice';
import settingsSlice from '@/redux/settings/settingsSlice';
import statsSlice from '@/redux/stats/statsSlice';
import profileSlice from '@/redux/profile/profileSlice';

const store = configureStore({
    reducer: {
        authentication: authSlice,
        catalog: catalogSlice,
        submittals: submittalsSlice,
        cms: cmsSlice,
        users: usersSlice,
        customers: customersSlice,
        settings: settingsSlice,
        stats: statsSlice,
        profile: profileSlice,
    },
});

export default store;
